<template>
	<nk-wrapper v-if="context.oeffnungszeiten" :id="options.id" spacing="md">
		<nk-accordion
			:title="context.titel || 'Öffnungszeiten'"
			title-size="xl"
			:open="options.openAccordion || false"
		>
			<nk-row>
				<nk-col cols="shrink" class="hidden sm:block">
					<nk-icon
						:icon="'time'"
						size="2xl"
						:inline="false"
						:background-color="true"
						color="neutral"
						variant="boxed"
					/>
				</nk-col>
				<nk-col cols="auto">
					<div class="nk-cms-content" v-html="context.oeffnungszeiten" />
				</nk-col>
			</nk-row>
		</nk-accordion>
	</nk-wrapper>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {string} context.titel
 * @prop {string} context.oeffnungszeiten
 * @prop {boolean} options.openAccordion
 * @prop {boolean} options.id
 */
export default {
	name: 'NkTemplateOeffnungszeiten',
	mixins: [TemplatesDefault],
};
</script>
